import React from "react";
import { Box, ButtonBase, Tooltip, Typography } from "@mui/material";

interface FlyoutSubOptionProps {
  icon: React.ReactNode;
  label: string;
  description: string;
  onClick(): void;
  disabled?: boolean;
  /** Explains why the sub-option is disabled. */
  tooltip?: string;
}

/**
 * A choice within an expanded flyout option.
 */
export const FlyoutSubOption: React.FC<FlyoutSubOptionProps> = ({ icon, label, description, onClick, disabled = false, tooltip }) => (
  <Tooltip title={tooltip ?? ""} placement="right">
    {/* Disabled buttons don't fire the events tooltips listen to. */}
    <Box>
      <ButtonBase
        onClick={onClick}
        disabled={disabled}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          width: "100%",
          height: 40,
          px: 1,
          borderRadius: 1,
          textAlign: "left",
          opacity: disabled ? 0.45 : 1,
          "&:hover": { bgcolor: "background.paper" },
        }}
      >
        <Box color="primary.main" display="flex">
          {icon}
        </Box>
        <Box display="flex" flexDirection="column" flex={1} minWidth={0}>
          <Typography fontWeight={500} fontSize={13}>
            {label}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </ButtonBase>
    </Box>
  </Tooltip>
);

/**
 * Container for the choices within an expanded flyout option.
 */
export const FlyoutSubOptions: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box display="flex" flexDirection="column" gap={0.25} ml={2.75} p={0.5} bgcolor="action.hover" borderRadius={1}>
    {children}
  </Box>
);
